export default ({ app }, inject) => {
  inject('pattern', {
    tel: {
      mask: '994 00 000-00-00',
    },
    pin: {
      mask: /^[a-zA-Z0-9]{0,7}$/,
      prepare: val => val.toUpperCase().replace(/^O/g, '0'),
    },
    iban: {
      mask: '{AZ}00 aaaa #### #### #### #### ####',
      definitions: {
        '#': /^[a-zA-Z0-9]$/,
        a: /^[a-zA-Z]$/,
      },
      prepare: val => val.toUpperCase(),
    },
    password: {
      mask: /([a-zA-Z0-9!@#=%$><&§°~*()\\.+,/-])$/,
    },
    date: {
      mask: Date,
      pattern: 'd{.}m{.}Y',
      max: new Date(),
    },
    documentDate: {
      mask: Date,
      pattern: 'd{.}m{.}Y',
    },
    alphaNumeric: {
      mask: /^([-/ÇçƏəĞğŞşÜüÖöIıİi\w\s?]){0,50}$/,
    },
    AzeDocumentNumber: {
      mask: /^[0-9]{0,8}$/,
    },
    documentNumber: {
      mask: /^[0-9]{0,7}$/,
    },
    document: {
      mask: '#########',
      definitions: {
        '#': /[0-9]/,
      },
    },
    number: {
      mask: Number,
      min: 0,
    },
    smsCode: {
      mask: '0000',
    },
    emailCode: {
      mask: '00000',
    },
    financeRangeMask: {
      mask: Number,
      min: 0,
      max: 9999999999999.99,
    },
    incomeMask: {
      mask: Number,
      min: 0,
      max: 99999999.99,
    },
    expensesMask: {
      mask: Number,
      min: 0,
      max: 99999999.99,
    },
    epointIncomingPayment: {
      mask: /^(?=.*\d)\d*(?:\.\d{0,2})?$/,
    },
  });
};
